//
// Angular
//
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map} from 'rxjs/operators';
import { Observable} from 'rxjs';
//
// App
//
import { SharedDataService } from '../../core/services/shared-data.service';
import { CustomerDealSummary } from '../../shared/model/api/CustomerDealSummary';
import { DealSummaryView } from '../../shared/model/view-model/deal-summary-view';
//
// Libraries
//
import {isNil, cloneDeep} from 'lodash-es';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration'
import { ViewConstants } from 'src/app/constants';
import { Deal } from 'src/app/shared/model/api';
import { AppNotification } from 'src/app/shared/model/api/AppNotification';

 
 

@Injectable(
    {
        providedIn: 'root'
    }
)
export class AppNotificationService {
    private get dealerCode() {
        return this.sharedService.dealerCode;
    }; 
    constructor(
        private readonly httpClient: HttpClient ,
        private readonly environment: EnvironmentConfiguration,
        private readonly sharedService : SharedDataService){ 
    } 
    //
    // this service is only called once and it returns the initial notifications for the app
    // after that, websocket is used to return notification/toast/etc at realtime.
    //
    public fetchNotifications(): Observable<AppNotification[]> {        
            let url = this.environment.MST_BASE_SERVICE_URL +`retail-deals/dealers/${this.dealerCode}/offers/current`;

            let params = new HttpParams()
            params = params.append('status', String('PENDING REVIEW,FINALIZED'));
            params = params.append('visitedStatus', String('notVisited'));

            return this.httpClient.get(url, { params: params }).pipe(
                map(o => this.formatData(o)
            ));
        // } 
        // else
        //     return of();
    }
    public clearAllNotifications() {
        // if (this.autorizationService.hasFeatureAccess(ViewConstants.FEATURE_DEALNOTIFICATION)) {   
            //https://mobile-api.rti.qa.toyota.com/
            let url =
            this.environment.MST_BASE_SERVICE_URL + `user/${this.dealerCode}/preferences/nouserid?clearAll=true`; 
 
            return this.httpClient.post(url,{})
        // }  
    }  
    //
    // private methods
    //
    private formatData(data: any): AppNotification[] {
        
        let returnValue : AppNotification[] = [];
        
        if(Array.isArray(data)) {
            let tempList = this.formatDataforDealView(data);
            tempList.deals.forEach( e =>
                returnValue.push({
                                    deal: { 
                                        dealTransactionId: e.deal.dealTransactionId,
                                        dealType: e.deal.dealType,
                                        paymentType:  e.deal.paymentType,
                                        status:  e.deal.status,
                                        onlineStatus: this.sharedService.getOnlineStatus(e.deal),
                                        updatedDate:  e.deal.updatedDate,
                                        salesPersonComments:   e.deal.salesPersonComments,
                                        salesPerson:  e.deal.salesAssociate.salesConsultant, 
                                        dealTermComment: {
                                            userRole: "",//"SALES_MANAGER"
                                            commentDate: "",//"2020-01-15 21:15:12"
                                            commentTXT: "",//"hai this is 2nd message to test chat"
                                            commentGivenBy: ""
                                        },
                                        writeupType :  e.deal.writeupType,
                                        reviewManager: e.deal.reviewManager,
                                        isToast:false
                                    },
                                    customer :{
                                        firstName: e.customer.firstName,
                                        lastName: e.customer.lastName
                                    }})
            );
        } 
        return returnValue;
    }
    // 
    // Method to format the service response data in Deal Summary View
    //  
    private formatDataforDealView(data: any): DealSummaryView {
        let dealSummaryData = this.setDefaulValue();
        let tempData: CustomerDealSummary[] = cloneDeep(data);
        tempData = tempData.filter(dt => (!isNil(dt.deal) && !isNil(dt.deal.status) && (isNil(dt.deal.visitedStatus) ||
            dt.deal.visitedStatus.toLocaleUpperCase() !== 'VISITED')
            && (dt.deal.status.toUpperCase() === 'PENDING REVIEW'
                || dt.deal.status.toUpperCase() === 'WRITE-UP PRICED'
                || dt.deal.status.toUpperCase() === 'FINALIZED') && ((!isNil(dt.deal.onlineStatus)?dt.deal.onlineStatus:"")!=="READY TO SHARE WITH DEALER")));
        tempData.forEach(row => {
            if (row.customer && row.customer.firstName && row.customer.lastName) {
                row.customer = (<any>Object).assign({}, row.customer, {
                    customerFullName: row.customer.firstName + ' ' + row.customer.lastName
                });
            }
            if (row.vehicle && row.vehicle.modelYear && row.vehicle.modelMarketingName) {
                row.vehicle = (<any>Object).assign({}, row.vehicle, {
                    modelName: row.vehicle.modelYear + ' ' + row.vehicle.modelMarketingName
                });
            }
    
            if (row.deal.status) { if (row.deal.status === 'PENDING REVIEW') {
                row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                    dealStatus: 'Pending Review'
                }); 
                row.deal.status='Pending Review';
                
            } else if (row.deal.status.toUpperCase() === 'INITIATED') {
                row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                    dealStatus: 'Initiated'
                });
                row.deal.status='Initiated';
            }
            else if (row.deal.status.toUpperCase() === 'FINALIZED') {
                row.dealStatus = (<any>Object).assign('', row.dealStatus, {

                    dealStatus: 'Finalized'
               });
               row.deal.status='Finalized';
            }
            else if (row.deal.status.toUpperCase() === 'WRITE-UP PRICED') {
                row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                    dealStatus: 'Write-up Priced'
                });
                row.deal.status='Write-up Priced';
            }
            else if (row.deal.status.toUpperCase() === 'DEALER APPROVED') {
                row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                    dealStatus: 'Dealer Approved'
                });
                row.deal.status='Dealer Approved';
            }
            else if (row.deal.status.toUpperCase() === 'TRADE APPROVED') {
                row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                    dealStatus: 'Trade Approved'
                });
                row.deal.status='Trade Approved';
            }
            else if (row.deal.status.toUpperCase() === 'EXPIRED') {
                row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                    dealStatus: 'Expired'
                });
                row.deal.status='Expired';
            }
            else if (row.deal.status.toUpperCase() === 'CANCELLED') {
                row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                    dealStatus: 'Cancelled'
                });
                row.deal.status='Cancelled';
            }
            else if (this.sharedService.showContractApproved && row.deal.status.toUpperCase() === ViewConstants.DEAL_STATUS_CONTRACT_APPROVED.toUpperCase()) {
                row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                    dealStatus: 'Contract Approved'
                });
                row.deal.status='Contract Approved';
            }
                else if (row.deal.status.indexOf('_') > 0) {
                    row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                        dealStatus: row.status.replace('_', ' ')
                    });
                } else {
                    row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                        dealStatus: row.deal.status
                    });
                }
            }
            let tempDealType = '';
            let tempPaymentType = '';
            if (!isNil(row.deal.dealType)) {
                tempDealType = row.deal.dealType;
            }
            if (!isNil(row.deal.paymentType)) {
                tempPaymentType = row.deal.paymentType;
            }
    
            if ((tempDealType.toLowerCase() === 'tradein') ||
                (tempDealType.toLowerCase() === 'tradein&payment')) {
                tempDealType = 'Trade'
            } else {
                tempDealType = '';
            }
    
            if (tempPaymentType.toLowerCase() === 'apr') {
                tempPaymentType = 'Finance';
            } else if (tempPaymentType.toLowerCase() === 'lease') {
                tempPaymentType = 'Lease';
            } else if (tempPaymentType.toLowerCase() === 'cash') {
                tempPaymentType = 'Cash';
            }
    
            let offerType = '';
            if (tempDealType !== '' && tempPaymentType !== '') {
                offerType = tempDealType + ' - ' + tempPaymentType;
            } else if (tempDealType !== '') {
                offerType = tempDealType;
            } else if (tempPaymentType !== '') {
                offerType = tempPaymentType;
            }
    
            row.estimatedOffer = (<any>Object).assign({}, {}, {
                dealtype: offerType
            });
    
            // For Trade Deal type will show the trade vin(old vin).
            // If we have more than one trade in vin
            // then will show the first vin. 
            if (offerType === 'Trade') {
                if (row.tradeIns && row.tradeIns.length > 0) {
                    row.vehicle = (<any>Object).assign({}, row.vehicle, {
                        vin: row.tradeIns[0].vin
                    });
                } 
                // else {
                //     row.vehicle = (<any>Object).assign({}, row.vehicle, {
                //         vin: ''
                //     });
                // }
            }
    
            if (row.deal.updatedDate) {
                row.updatedDate = (<any>Object).assign('', row.updatedDate, {
                    updatedDate: this.formatDate(row.deal.updatedDate),
                    updatedDateAsDate: new Date(row.deal.updatedDate),
                    updatedDateAsString: row.deal.updatedDate
                });
            }
        });
        dealSummaryData.deals = tempData;

        dealSummaryData.deals.forEach( e => {
            e.deal.writeupType = this.getWriteupType(e.deal)
        });

        return dealSummaryData;
    }

    /*
    * Method used to set the default initial state of DealSummaryState
    */
    private setDefaulValue(): DealSummaryView {
        //let dataFormatter = <SharedFunctionService>new Object();
        let dealSummaryData: DealSummaryView = <DealSummaryView>new Object();
        dealSummaryData.deals = [];
        dealSummaryData.hiddenRecords = {};
        dealSummaryData.userView = {};
        dealSummaryData.successMessage = '';
        dealSummaryData.failureMessage = '';
        dealSummaryData.globalSearchFilterValue = '';
        dealSummaryData.originalDeals = [];
        dealSummaryData.customerLeads = [];
        return dealSummaryData;
    }

    /**
     * Method used to format the date value (if the value is less
     * than 9 then will 0 before the value)
     */
    private formatDateValue(value) {
        return value > 9 ? '' + value : '0' + value;
    }
    private  formatDate(date, convertUTC: boolean = true) {
        let modifiedDate = new Date(date);
        let updatedDate: any = {};
        if(convertUTC) {
            modifiedDate.setHours(modifiedDate.getHours() - 8);
        }
        let day = this.formatDateValue(modifiedDate.getDate());
        let month = this.formatDateValue(modifiedDate.getMonth() + 1);
        let year = modifiedDate.getFullYear();
        let hours = modifiedDate.getHours();
        let minutes = this.formatDateValue(modifiedDate.getMinutes());
        let h = (hours % 12) || 12;
        let ampm = hours < 12 ? 'AM' : 'PM';
        let timeString = this.formatDateValue(h) + ':' + minutes.toString() + ' ' + ampm;
        // row.updatedDate = (<any>Object).assign('', row.updatedDate, {
        //     updatedDate: timeString + '&nbsp;&nbsp;&nbsp; ' + month + '.' + day + '.'
        //     + year
        // });
        updatedDate = timeString + ' ' + month + '.' + day + '.'
            + year;
        return updatedDate;
    }
    private getWriteupType(deal : Deal):string{
         
        if (deal.paymentType == null && deal.dealType == "TRADEIN")
            return "Trade";
        if (deal.paymentType != null && ["TRADEIN", "TRADEIN&PAYMENT"].includes(deal.dealType)){
          switch(deal.paymentType)
          {
            case "LEASE":
                return "Trade - Lease";
            case "FINANCE":
                return "Trade - Finance";
            case "CASH":
                return "Trade - Cash";
            case "APR":
            return "Trade - Finance";
          }
        }
        if (deal.paymentType != null && !["TRADEIN", "TRADEIN&PAYMENT"].includes(deal.dealType)){
          switch(deal.paymentType)
          {
            case "LEASE":
                return "Lease";
            case "FINANCE":
                return "Finance";
            case "CASH":
                return "Cash";
            case "APR":
            return "Finance";
          }
        }
        //return returnValue;
      }
    
}
